// Selo de tipo de cliente (PF/PJ).
//
// As cores vêm da paleta de chips do tenant, que já tem variante para claro e
// escuro. PJ e PF não são severidade, são categoria — por isso dois tons
// neutros e distintos entre si, em vez de um par bom/ruim.
const seloBase = {
	height: 22,
	minWidth: 44,
	fontWeight: 600,
	fontSize: "0.7rem",
	letterSpacing: "0.04em",
	borderRadius: "6px",
};

const styles = (theme) => ({
	chipPj: {
		...seloBase,
		color: theme.palette.chip.colorText.medium,
		backgroundColor: theme.palette.chip.background.medium,
	},
	chipPf: {
		...seloBase,
		color: theme.palette.chip.colorText.low,
		backgroundColor: theme.palette.chip.background.low,
	},
	opcaoFiltro: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 1.5,
		width: "100%",
	},
	valorSelecionado: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		height: "100%",
	},
});

export default styles;
